/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon16Light = forwardRef('ArrowAUpLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3 10.5a.5.5 0 0 0 1 0V4.707l8.146 8.147a.5.5 0 0 0 .708-.708L4.707 4H10.5a.5.5 0 0 0 0-1h-6A1.5 1.5 0 0 0 3 4.5v6Z" })));
});
